import Immutable from "immutable";

export class ModalBillingPaymentRecord extends Immutable.Record({
  cardholderName: "",
  address: "",
  city: "",
  country: "",
  postalCode: "",
  newCard: true,
  isLoading: false,
  canSubmit: false,
  isCardValid: false
}) {}
